import { render } from "./downTipInfo.vue?vue&type=template&id=ab105410"
import script from "./downTipInfo.vue?vue&type=script&lang=js"
export * from "./downTipInfo.vue?vue&type=script&lang=js"
script.render = render

export default script